import withDraft from '@/utils/draftHelper';
import { closeDatasetCollectionState } from './state';
import actions from '../../constants';

const closeSettingsDatasetCollection = withDraft((draft, { code }) => {
  closeDatasetCollectionState(draft, { category: 'settings', code });
});

const closeOpenDatasetCollection = withDraft((draft, { code }) => {
  closeDatasetCollectionState(draft, { category: 'open', code });
});

export default {
  [actions.FINISH_DATASET_WIZARD]: closeSettingsDatasetCollection,
  [actions.CLOSE_DATASET]: closeOpenDatasetCollection,
};
